<script setup>
import { computed } from 'vue'
import { signalToneEnum, signalToneColor } from '@/composables/dashboard-kpi'

const props = defineProps({
  text: { type: String, required: true },
  tone: { type: Number, default: signalToneEnum.NEUTRAL },
})

const colorClass = computed(() => `text-${signalToneColor(props.tone)}`)
</script>

<template>
  <span class="signal-value text-weight-medium" :class="colorClass">{{ text }}</span>
</template>

<style scoped>
.signal-value {
  font-variant-numeric: tabular-nums;
  font-size: 0.8125rem;
  line-height: 1;
}
</style>
